import moment from "moment";
export var footermarketStatusStream = function (data, streamdata) {
    return data && data.length > 0 && streamdata && streamdata !== null
        ? data.map(function (el) {
            return {
                exc: el.exc,
                sts: streamdata.status[el.exc]
                    ? streamdata.status[el.exc]
                    : el.sts,
            };
        })
        : data
            ? data
            : [];
};
export var marketStatusMapper = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var resp = {
        lut: (_a = moment()) === null || _a === void 0 ? void 0 : _a.format("YYYY/MM/DD HH:mm:ss"),
        status: {
            BSE: (_c = (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.find(function (el) { return (el === null || el === void 0 ? void 0 : el.exc) == "BSE"; })) === null || _c === void 0 ? void 0 : _c.sts,
            NSE: (_e = (_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.find(function (el) { return (el === null || el === void 0 ? void 0 : el.exc) == "NSE"; })) === null || _e === void 0 ? void 0 : _e.sts,
            NFO: (_g = (_f = data === null || data === void 0 ? void 0 : data.data) === null || _f === void 0 ? void 0 : _f.find(function (el) { return (el === null || el === void 0 ? void 0 : el.exc) == "NFO"; })) === null || _g === void 0 ? void 0 : _g.sts,
            NCDX: (_j = (_h = data === null || data === void 0 ? void 0 : data.data) === null || _h === void 0 ? void 0 : _h.find(function (el) { return (el === null || el === void 0 ? void 0 : el.exc) == "NCDEX"; })) === null || _j === void 0 ? void 0 : _j.sts,
            CDS: (_l = (_k = data === null || data === void 0 ? void 0 : data.data) === null || _k === void 0 ? void 0 : _k.find(function (el) { return (el === null || el === void 0 ? void 0 : el.exc) == "CDS"; })) === null || _l === void 0 ? void 0 : _l.sts,
            MCX: (_o = (_m = data === null || data === void 0 ? void 0 : data.data) === null || _m === void 0 ? void 0 : _m.find(function (el) { return (el === null || el === void 0 ? void 0 : el.exc) == "MCX"; })) === null || _o === void 0 ? void 0 : _o.sts,
            BFO: (_q = (_p = data === null || data === void 0 ? void 0 : data.data) === null || _p === void 0 ? void 0 : _p.find(function (el) { return (el === null || el === void 0 ? void 0 : el.exc) == "BFO"; })) === null || _q === void 0 ? void 0 : _q.sts,
        },
    };
    return resp;
};
